import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import ProtectedRoute from './components/ProtectedRoute'

// Landings (eager — 1ª impressão de marketing)
import Landing from './pages/Landing'                  // / (paciente)
import LandingMedico from './pages/LandingMedico'       // /medicos
import LandingPsicologo from './pages/LandingPsicologo' // /psicologos

// Auth: pequeno mas usado constantemente — eager
import Login from './pages/Login'
import Cadastro from './pages/Cadastro'

// Resto: lazy (code-split por rota)
const EsqueciSenha = lazy(() => import('./pages/EsqueciSenha'))
const Onboarding = lazy(() => import('./pages/Onboarding'))
const OnboardingMedico = lazy(() => import('./pages/OnboardingMedico'))
const Home = lazy(() => import('./pages/Home'))
const Perfil = lazy(() => import('./pages/Perfil'))
const PerfilMedico = lazy(() => import('./pages/PerfilMedico'))
const CheckIn = lazy(() => import('./pages/CheckIn'))
const MedicoHome = lazy(() => import('./pages/MedicoHome'))
const MedicoPaciente = lazy(() => import('./pages/MedicoPaciente'))
const MedicoAnalytics = lazy(() => import('./pages/MedicoAnalytics'))
const VisitaDetalhe = lazy(() => import('./pages/VisitaDetalhe'))
const Convite = lazy(() => import('./pages/Convite'))
const Chat = lazy(() => import('./pages/Chat'))
const Agenda = lazy(() => import('./pages/Agenda'))
const Planos = lazy(() => import('./pages/Planos'))
const ContaAssinatura = lazy(() => import('./pages/ContaAssinatura'))
const AreaMedico = lazy(() => import('./pages/AreaMedico'))
const Clinica = lazy(() => import('./pages/Clinica'))
const Faq = lazy(() => import('./pages/Faq'))
const Colateral = lazy(() => import('./pages/Colateral'))

function FallbackCarregando() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-anamis-50">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 rounded-full border-4 border-anamis-200 border-t-anamis-600 animate-spin" />
        <span className="text-sm text-slate-500">Carregando…</span>
      </div>
    </div>
  )
}

export default function App() {
  return (
    <Suspense fallback={<FallbackCarregando />}>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/medicos" element={<LandingMedico />} />
        <Route path="/psicologos" element={<LandingPsicologo />} />
        <Route path="/login" element={<Login />} />
        <Route path="/cadastro" element={<Cadastro />} />
        <Route path="/esqueci-senha" element={<EsqueciSenha />} />
        <Route path="/convite/:token" element={<Convite />} />
        <Route path="/colateral/:token" element={<Colateral />} />
        <Route path="/planos" element={<Planos />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/duvidas" element={<Faq />} />
        <Route path="/conta/assinatura" element={
          <ProtectedRoute>
            <ContaAssinatura />
          </ProtectedRoute>
        } />

        {/* Onboardings (sem checagem onboardingCompleto) */}
        <Route path="/onboarding" element={
          <ProtectedRoute permitirSemOnboarding rolesPermitidas={['paciente']}>
            <Onboarding />
          </ProtectedRoute>
        } />
        <Route path="/onboarding-medico" element={
          <ProtectedRoute permitirSemOnboarding rolesPermitidas={['medico']}>
            <OnboardingMedico />
          </ProtectedRoute>
        } />

        {/* Paciente */}
        <Route path="/app" element={
          <ProtectedRoute rolesPermitidas={['paciente']}>
            <Home />
          </ProtectedRoute>
        } />
        <Route path="/perfil" element={
          <ProtectedRoute rolesPermitidas={['paciente']}>
            <Perfil />
          </ProtectedRoute>
        } />
        <Route path="/checkin" element={
          <ProtectedRoute rolesPermitidas={['paciente']}>
            <CheckIn />
          </ProtectedRoute>
        } />
        <Route path="/area/:medicoUid" element={
          <ProtectedRoute rolesPermitidas={['paciente']}>
            <AreaMedico />
          </ProtectedRoute>
        } />
        <Route path="/visita/:vid" element={
          <ProtectedRoute rolesPermitidas={['paciente']}>
            <VisitaDetalhe />
          </ProtectedRoute>
        } />
        <Route path="/agenda" element={
          <ProtectedRoute rolesPermitidas={['paciente']}>
            <Agenda />
          </ProtectedRoute>
        } />
        <Route path="/chat" element={
          <ProtectedRoute rolesPermitidas={['paciente']}>
            <Chat />
          </ProtectedRoute>
        } />
        <Route path="/chat/:outroUid" element={
          <ProtectedRoute rolesPermitidas={['paciente']}>
            <Chat />
          </ProtectedRoute>
        } />

        {/* Médico */}
        <Route path="/medico" element={
          <ProtectedRoute rolesPermitidas={['medico']}>
            <MedicoHome />
          </ProtectedRoute>
        } />
        <Route path="/medico/paciente/:uid" element={
          <ProtectedRoute rolesPermitidas={['medico']}>
            <MedicoPaciente />
          </ProtectedRoute>
        } />
        <Route path="/medico/analytics" element={
          <ProtectedRoute rolesPermitidas={['medico']}>
            <MedicoAnalytics />
          </ProtectedRoute>
        } />
        <Route path="/medico/visita/:patientUid/:vid" element={
          <ProtectedRoute rolesPermitidas={['medico']}>
            <VisitaDetalhe />
          </ProtectedRoute>
        } />
        <Route path="/medico/chat" element={
          <ProtectedRoute rolesPermitidas={['medico']}>
            <Chat />
          </ProtectedRoute>
        } />
        <Route path="/medico/chat/:outroUid" element={
          <ProtectedRoute rolesPermitidas={['medico']}>
            <Chat />
          </ProtectedRoute>
        } />
        <Route path="/perfil-medico" element={
          <ProtectedRoute rolesPermitidas={['medico']}>
            <PerfilMedico />
          </ProtectedRoute>
        } />
        <Route path="/clinica" element={
          <ProtectedRoute rolesPermitidas={['medico']}>
            <Clinica />
          </ProtectedRoute>
        } />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  )
}
